const API_URL = process.env.REACT_APP_API_URL || '';

/**
 * Strips spaces and the leading `+` so the number can be used in URLs.
 * "+91 96388 53253" → "919638853253"
 * "919638853253"    → "919638853253"
 */
export function toDialable(raw) {
  if (!raw) return '';
  return raw.replace(/\s+/g, '').replace(/^\+/, '');
}

/** Returns a wa.me URL from any Indian number format. */
export function toWhatsAppUrl(raw) {
  return `https://wa.me/${toDialable(raw)}`;
}

/** Returns a tel: URL from any Indian number format. */
export function toTelUrl(raw) {
  return `tel:+${toDialable(raw)}`;
}

let cache = null;

export async function fetchSettings() {
  if (cache) return cache;
  const res = await fetch(`${API_URL}/settings`);
  if (!res.ok) throw new Error(`Settings fetch failed: ${res.status}`);
  const json = await res.json();
  cache = json.data;
  return cache;
}
